import { useTranslation } from "react-i18next";

// Import SVG assets as React components using ?react suffix
import InstagramIcon from "../assets/instangram.svg?react";
import WhatsappIcon from "../assets/whatsapp.svg?react";
import MessengerIcon from "../assets/messenger.svg?react";

const SocialShareButtons = () => {
  const { t } = useTranslation();

  // Texte de partage traduit
  const shareText = t(
    "social.shareText",
    "Découvrez RunMemories: créez votre affiche personnalisée de course ou d'exploit sportif en 1 clic ! 🚀"
  );
  const appUrl = window.location.origin || "https://app.runmemories.com";

  // Générer les liens de partage
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
    `${shareText} ${appUrl}`
  )}`;
  // Instagram ne permet pas le partage direct d'un texte, mais on peut rediriger vers le profil ou la page d'accueil
  const instagramUrl = `https://www.instagram.com`;

  // Messenger sharing nécessite un Facebook App ID
  const fbAppId = import.meta.env.VITE_FACEBOOK_APP_ID || "YOUR_FB_APP_ID";
  const messengerUrl =
    fbAppId && fbAppId !== "YOUR_FB_APP_ID"
      ? `https://www.facebook.com/dialog/send?app_id=${fbAppId}&link=${encodeURIComponent(
          appUrl
        )}&redirect_uri=${encodeURIComponent(appUrl)}&display=popup`
      : "#";

  // Tooltips traduits
  const shareWhatsapp = t("social.shareWhatsapp", "Partager sur WhatsApp");
  const shareInstagram = t("social.shareInstagram", "Partager sur Instagram");
  const shareMessenger = t("social.shareMessenger", "Partager sur Messenger");

  return (
    <div className="fixed top-1/2 right-0 z-[1000] -translate-y-1/2">
      <div className="flex flex-col gap-3 bg-[#1e1e1e]/95 rounded-l-xl py-[10px] pr-[6px] pl-[10px] shadow-[0_2px_8px_rgba(0,0,0,0.15)]">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={shareWhatsapp}
          className="text-[#25D366] hover:opacity-75 transition-opacity"
        >
          <WhatsappIcon className="w-7 h-7" />
        </a>
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={shareInstagram}
          className="text-[#E1306C] hover:opacity-75 transition-opacity"
        >
          <InstagramIcon className="w-7 h-7" />
        </a>
        <a
          href={messengerUrl}
          onClick={(e) => {
            if (!fbAppId || fbAppId === "YOUR_FB_APP_ID") {
              e.preventDefault();
              alert("Facebook App ID is not configured for Messenger sharing.");
              return false;
            }
            // Ouvre Messenger dans une popup
            window.open(messengerUrl, "_blank", "width=600,height=400");
            e.preventDefault();
            return false;
          }}
          target="_blank"
          rel="noopener noreferrer"
          title={shareMessenger}
          className="text-[#0084FF] hover:opacity-75 transition-opacity"
        >
          <MessengerIcon className="w-7 h-7" />
        </a>
      </div>
    </div>
  );
};

export default SocialShareButtons;